import React, {Component} from "react";
import {Provider} from "react-redux";
import {createStore, applyMiddleware, compose} from "redux";
import thunk from "redux-thunk";
import affiliateMemberReducer from "../AffiliateMember/reducers";
import AffiliateMemberDetailsForm from "./components/AffiliateMemberDetailsForm";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = (initialState = {}) => {
  return createStore(
    affiliateMemberReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunk
      )
    )
  );
}

export default class AffiliateMember extends Component {
  render() {
    const {affiliate_member, affiliate_member_detail, affiliate_member_address, affiliate_member_contacts, organization, current_user, state_options, statuses_options, ui} = this.props;
    return (
      <Provider
        store={configureStore({
          affiliateMember: affiliate_member,
          affiliateMemberDetail: affiliate_member_detail,
          affiliateMemberAddress: affiliate_member_address,
          affiliateMemberContacts: affiliate_member_contacts,
          stateOptions: state_options,
          statusesOptions: statuses_options,
          currentUser: current_user,
          organization: organization,
          ui: ui
        })}>
        <AffiliateMemberDetailsForm/>
      </Provider>
    );
  }
}
